import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import Select, { SelectOption } from '../Select';
import { setAppData } from '../../WarrantyStandardForm/redux/actions'
import ReactLib from '@owenscorning/react-library'
import qs from 'qs';
import _ from 'lodash'

const { Connect: { Spinner, ReactUtils: { useLoading }, FormElements: { Form, Text } } } = ReactLib

const ADDRESS = {
  address_line1: '1 Owens Corning Pkway',
  address_line2: '',
  city: 'Toledo',
  state_province: 'OH',
  country_code: 'USA',
  postal_code: '43604'
}

const DATE = {
  install_day: 20,
  install_month: 2,
  install_year: 2022
}

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

function camelToUid(camel) {
  return (camel).replace(/([a-z0-9]+)([A-Z].+)/g, '$1_$2').toLowerCase()
}

const buildApiUrl = ({address, date}) => `${MDMS_URL}/api/v2/contractor/warranties/available-product-lines?${qs.stringify(
  _.mapKeys({
    ...address,
    ...date
  }, (v,k) => camelToUid(k)))}`

const ShingleLineSelect = ({apiUrl, shingleLine, shingleColor, setAppData, propertyAddress, installDate, appData}) => {
  apiUrl = buildApiUrl({address: propertyAddress, date: installDate})
  const [loadWrapper, loading, loadError] = useLoading()
  const shingleData = appData.shingleData || {}

  const fetchShingleLines = loadWrapper(async () => {
      console.log('sending request for shingle lines',  apiUrl)
      const response = await fetch(apiUrl).then(response => response.json())
      console.log('got respoonse for shingle line select',  response)
      setAppData({shingleData: response})
  })

  useEffect(() => {
    // doing fetch on first render, may need optimized for forward-backward traversal
    fetchShingleLines()
  }, [])
  const shingleLines = shingleData.products?.sort((a, b) => a.product_legal_name.localeCompare(b.product_legal_name)) || []
  const allShingleColors = shingleData.colors || {}
  const selectedColors = allShingleColors[shingleLine]?.sort((a, b) => a.color_name.localeCompare(b.color_name)) || []

  return (
    <>
      <InputWrapper>
        <Select
          value={shingleLine}
          fieldKey={'shingleLine'}
          options={shingleLines.map(({uid, product_legal_name: name}, index) => <SelectOption key={index} value={uid} text={name} />)}
          htmlAttributes={{
            placeholder: 'Shingle Line',
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <Select
          value={shingleColor}
          fieldKey={'shingleColor'}
          options={selectedColors.map(({color_name: color}, index) => <SelectOption key={index} value={color} text={color} />)}
          htmlAttributes={{
            placeholder: 'Shingle Color',
          }}
        />
      </InputWrapper>
    </>
  )
}

const mapStateToProps = state => (
  {
    shingleLine: state.formData.shingleLine,
    shingleColor: state.formData.shingleColor,
    propertyAddress: state.formData.propertyAddress,
    installDate: {
      installYear: state.formData.installDateYear,
      installMonth: state.formData.installDateMonth,
      installDay: state.formData.installDateDay
    },
    appData: state.appData
  }
);

const mapDispatchToProps = dispatch => (
  {
    setAppData: (hash) => dispatch(setAppData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShingleLineSelect);


